import { Layout, MenuProps } from "antd";
import { useHistory } from "react-router-dom";
import "../RegisterWolfScreen/Register.css";
import React from "react";
type Props = {
  responeConfig?: any;
  sideMenu?: React.ReactNode;
  children: React.ReactNode;
};
const LayoutBase: React.FC<Props> = ({ responeConfig, sideMenu, children }) => {
  const { Header, Content, Sider } = Layout;
  let history = useHistory();
  return (
    <Layout>
      {responeConfig && (
        <>
          <Header className="header">
            <img
              style={{
                width: `${responeConfig?.cssConfig?.width}`,
                height: "70px",
                background: "white",
              }}
              className="img-logo"
              src={responeConfig?.pathLogoNav}
              alt="logo"
              onClick={() => history.push("/login")}
            />
          </Header>

          <div className="toolbar" style={{ height: "70px" }}></div>
        </>
      )}
      <Layout className="content-container">
        {sideMenu && (
          <Sider width={200} className="side-bar">
            {sideMenu}
          </Sider>
        )}
        <Content
          className="site-layout-background"
          style={{
            padding: 0,
            margin: 0,
            minHeight: 280,
            marginRight: "150px",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutBase;
